/**
 * Report Error reducer.
 * @module reducers/report_error/report_error
 */

import { REPORT_ERROR, RESET_REPORT_ERROR } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
};

/**
 * Report Error reducer.
 * @function report_error
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function report_error(state = initialState, action = {}) {
  switch (action.type) {
    case RESET_REPORT_ERROR:
      return {
        ...initialState,
      };
    case `${REPORT_ERROR}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${REPORT_ERROR}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
      };
    case `${REPORT_ERROR}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
